import React, { useEffect, useState, useRef } from 'react';
import { View, Text, ScrollView, StyleSheet, TouchableOpacity, Dimensions, Platform } from 'react-native';
import { Ionicons, FontAwesome5, Feather, MaterialCommunityIcons } from '@expo/vector-icons';
import { navigate } from '../../../../../navigation/RootNavigation';
import { useSelector } from 'react-redux';
import getPlatformType from '../../../../../helpers/helpers';

const TABS = [
  { label: 'HOME', icon: <Ionicons name="home-outline" size={18} color="white" />,
  routeKey:"TeanantOnboarding"
},
  { label: 'TENANTS', icon: <FontAwesome5 name="user-circle" size={16} color="white" /> ,
  routeKey:"TenantDetails",},
  { label: 'LANDLORDS & DOCUMENTATION', icon: <Feather name="file-text" size={16} color="white" /> ,
  routeKey:"PropertyDocumentation"},
  { label: 'RENTAL OFFER', icon: <Feather name="calendar" size={16} color="white" /> ,
  routeKey:"RentalOffers"},
  { label: 'HOLDING DEPOSIT', icon: null,
    routeKey:"HoldingDeposit" },
    
  { label: 'ID & FULL REFERENCE', icon: <MaterialCommunityIcons name="qrcode-scan" size={16} color="white" />,
  routeKey:"IdAndReference" },
  { label: 'TENANCY AGREEMENT', icon: <MaterialCommunityIcons name="signature-freehand" size={18} color="white" /> ,
  routeKey:"TenancyAgreement"},
  { label: 'MOVE IN', icon: null,
    routeKey:"MoveIn" },
  { label: 'DEPOSIT PROTECTION', icon: <Feather name="credit-card" size={16} color="white" /> ,
  routeKey:"DepositProtectHomeSetup"},
  { label: 'Maintenance', icon: <MaterialCommunityIcons name="tools" size={22} color={"rgba(255,255,255,0.9)"}/>,
  routeKey:"Maintenance"},

];

const TABSRENEW = [
  { label: 'HOME', icon: <Ionicons name="home-outline" size={18} color="white" />,
  routeKey:"TeanantOnboarding"
},
  { label: 'TENANTS', icon: <FontAwesome5 name="user-circle" size={16} color="white" /> ,
  routeKey:"TenantDetails",},
  { label: 'LANDLORDS & DOCUMENTATION', icon: <Feather name="file-text" size={16} color="white" /> ,
  routeKey:"PropertyDocumentation"},
  { label: 'RENEWAL OFFER', icon: <Feather name="calendar" size={16} color="white" /> ,
  routeKey:"RentalOffers"},
  { label: 'HOLDING DEPOSIT', icon: null,
    routeKey:"HoldingDeposit" },
    { label: 'RENEWAL PAYMENTS', icon: null,
        routeKey:"MoveIn" },
  { label: 'ID & FULL REFERENCE', icon: <MaterialCommunityIcons name="qrcode-scan" size={16} color="white" />,
  routeKey:"IdAndReference" },
  { label: 'TENANCY AGREEMENT', icon: <MaterialCommunityIcons name="signature-freehand" size={18} color="white" /> ,
  routeKey:"TenancyAgreement"},
  { label: 'DEPOSIT PROTECTION', icon: <Feather name="credit-card" size={16} color="white" /> ,
  routeKey:"DepositProtectHomeSetup"},
  { label: 'MAINTENANCE', 
    icon: <MaterialCommunityIcons name="tools" size={22} color={"rgba(255,255,255,0.9)"}/>,
  routeKey:"Maintenance"},
];

const HorizontalTabSlider = (props) => {
  const [selectedTab, setSelectedTab] = useState('');
  const [windowWidth, setWindowWidth] = useState(Dimensions.get('window').width);
  const scrollViewRef = useRef(null);
  const tabRefs = useRef({});
  const layout = getPlatformType();
  const isMobile = layout === 'phone';
  
  const openflow_id = useSelector((state) => state?.tenant?.flowIdInfo?.openflow_id);
  const is_renewed = useSelector((state) => state?.tenant?.flowIdInfo?.is_renewed);
  const layoutType = useSelector((state) => state?.AppReducer?.layoutType);
  const [contentWidth, setContentWidth] = useState(0);
  const [finalTabs, setFinalTabs] = useState([]);
  const [containerWidth, setContainerWidth] = useState(0);
  const [scrollX, setScrollX] = useState(0);
console.log("is_renewed",is_renewed)
  // Handle window resize for responsive design
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(Dimensions.get('window').width);
    };

    // Add event listener for window resize on web
    if (Platform.OS === 'web') {
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  useEffect(() => {
    if (props?.props?.props?.route?.name) {
      setSelectedTab(props?.props?.props?.route?.name);
    } else {
      setSelectedTab("");
    }
  }, [props?.props?.props?.route?.name]);
  useEffect(() => {
    setFinalTabs(is_renewed ? TABSRENEW : TABS )
  }, [is_renewed]);


  // Scroll to selected tab when it changes
  useEffect(() => {
    if (selectedTab && scrollViewRef.current) {
      const tabIndex = finalTabs.findIndex(tab => tab.routeKey === selectedTab);
      
      if (tabIndex !== -1 && tabRefs.current[tabIndex]) {
        // Get the position of the selected tab
        tabRefs.current[tabIndex].measure((x, y, width, height, pageX, pageY) => {
          // Calculate the scroll position to center the tab
          const scrollToX = pageX - (windowWidth / 2) + (width / 2);
          
          // Scroll to the position with animation
          scrollViewRef.current.scrollTo({ x: scrollToX, animated: true });
        });
      }
    }
  }, [selectedTab, finalTabs, windowWidth, props?.props?.props?.route?.name]);

  
  // Adjust styles based on layout type
  const getResponsiveStyles = () => {
    if (layoutType === 'phone') {
      return {
        container: {
          paddingVertical: 8,
          paddingHorizontal: 4,
        },
        tab: {
          marginRight: 8,
          paddingVertical: 4,
          paddingHorizontal: 8,
          borderRadius: 8,
        },
        label: {
          fontSize: 10,
        },
        icon: {
          marginRight: 4,
        },
        viewHeight: 60
      };
    }
    return {
      container: {
        paddingVertical: 12,
        paddingHorizontal: 8,
      },
      tab: {
        marginRight: 16,
        paddingVertical: 6,
        paddingHorizontal: 14,
        borderRadius: 10,
      },
      label: {
        fontSize: 12,
      },
      icon: {
        marginRight: 6,
      },
      viewHeight: 70
    };
  };
  
  const responsiveStyles = getResponsiveStyles();
  const scrollHorizontal = (direction) => {
    if (scrollViewRef.current) {
      let step = containerWidth * 0.8;  // scroll almost a screen width
      let newX = direction === 'right'
        ? Math.min(scrollX + step, contentWidth - containerWidth)
        : Math.max(scrollX - step, 0);

      scrollViewRef.current.scrollTo({
        x: newX,
        animated: true,
      });

      setScrollX(newX);
    }
  };
  return (
    <View style={{ height: responsiveStyles.viewHeight }}>
      <View style={styles.scrollContainer}>
      <TouchableOpacity
            style={[
              styles.arrowButton,
              styles.leftArrow,
              (scrollX <= 1) && { opacity: 0.3 }  // Small tolerance at left edge
            ]}
            onPress={() => scrollHorizontal('left')}
            disabled={scrollX <= 1}
          >
            <Ionicons name="chevron-back" size={18} color="#fff" />
          </TouchableOpacity>
      <ScrollView 
        ref={scrollViewRef}
        horizontal 
        showsHorizontalScrollIndicator={false} 
        style={[styles.container, responsiveStyles.container]}
        scrollEventThrottle={16}
        onContentSizeChange={(w) => setContentWidth(w)}
        onLayout={(e) => setContainerWidth(e.nativeEvent.layout.width)}
        onScroll={(e) => setScrollX(e.nativeEvent.contentOffset.x)}
        decelerationRate="fast"
        snapToAlignment="center"
      >
        {finalTabs.map((tab, index) => {
          const isSelected = tab.routeKey === selectedTab;
          return (
            <TouchableOpacity
              key={index}
              ref={ref => tabRefs.current[index] = ref}
              style={[
                styles.tab, 
                responsiveStyles.tab,
                isSelected && styles.selectedTab
              ]}
              onPress={() => {
                navigate(tab?.routeKey, { id: openflow_id });
              }}
            >
              {tab.icon && (
                <View style={[styles.icon, responsiveStyles.icon]}>
                  {isSelected 
                    ? tab.icon 
                    : React.cloneElement(tab.icon, { color: '#6b7280' })
                  }
                </View>
              )}
              <Text 
                style={[
                  styles.label, 
                  responsiveStyles.label,
                  isSelected && styles.selectedLabel
                ]}
                numberOfLines={1}
              >
                {tab.label}
              </Text>
            </TouchableOpacity>
          );
        })}
      </ScrollView>
      <TouchableOpacity
            style={[styles.arrowButton, styles.rightArrow, (scrollX >= contentWidth - containerWidth - 1) && { opacity: 0.3 }]}
            onPress={() => scrollHorizontal('right')}
            disabled={scrollX >= contentWidth - containerWidth - 1}
          >
            <Ionicons name="chevron-forward" size={18} color="#fff" />
          </TouchableOpacity>
          </View>
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    paddingVertical: 12,
    paddingHorizontal: 8,
  },
  scrollContainer: {
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center',
  },
  arrowButton: {
    position: 'absolute',
    zIndex: 10,
    backgroundColor: '#7C3AED',
    borderRadius: 20,
    width: 28,
    height: 28,
    justifyContent: 'center',
    alignItems: 'center',
    ...Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.2,
        shadowRadius: 3,
      },
      android: {
        elevation: 4,
      },
    }),
  },
  leftArrow: {
    left: -17,
  },
  rightArrow: {
    right: -18,
  },
  tab: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 16,
    paddingVertical: 6,
    paddingHorizontal: 14,
    borderRadius: 10,
    backgroundColor: 'transparent',
  },
  selectedTab: {
    backgroundColor: '#8b5cf6', // purple
  },
  label: {
    fontSize: 12,
    color: '#6b7280',
    fontWeight: '500',
  },
  selectedLabel: {
    color: '#fff',
  },
  icon: {
    marginRight: 6,
  },
});

export default HorizontalTabSlider;